export default __webpack_public_path__ + "static/media/3536 spice rack D side.e25cf678.png";